import React from 'react';
import { useTheme } from '@zydalabs/storefront-components';
import { Button, Typography } from '@zydalabs/zac-react';

import { StyledTapDisplayCard, StyledCardInfoWrapper, StyledCardNumberRowWrapper } from './style';

const TapDisplayCard: React.FC<any> = ({ t, paymentCard, setIsPaymentIFrameVisible }) => {
  const theme = useTheme();

  return (
    <StyledTapDisplayCard>
      <StyledCardNumberRowWrapper>
        <StyledCardInfoWrapper>
          <Typography variant="body14" color={theme.color.bodyText} mb={`${theme.space[1]}px`}>
            {t('cardNumber')}
          </Typography>
          <Typography variant="body16" color={theme.color.headlineText} mt={`${theme.space[1]}px`}>
            {`****${paymentCard?.card.last_four}`}
          </Typography>
        </StyledCardInfoWrapper>
        <Button
          onClick={() => {
            setIsPaymentIFrameVisible(true);
          }}
          testId="change_payment_btn"
          variant="ghost"
          text={t('change')}
        />
      </StyledCardNumberRowWrapper>
      <StyledCardInfoWrapper>
        <Typography variant="body14" color={theme.color.bodyText} mb={`${theme.space[1]}px`}>
          {t('expirationDate')}
        </Typography>
        <Typography variant="body16" color={theme.color.headlineText} mt={`${theme.space[1]}px`}>
          {`${paymentCard?.card?.exp_month}/${paymentCard?.card?.exp_year}`}
        </Typography>
      </StyledCardInfoWrapper>
      <StyledCardInfoWrapper>
        <Typography variant="body14" color={theme.color.bodyText} mb={`${theme.space[1]}px`}>
          {t('cardHolder')}
        </Typography>
        <Typography variant="body16" color={theme.color.headlineText} mt={`${theme.space[1]}px`}>
          {`${paymentCard?.card?.name}`}
        </Typography>
      </StyledCardInfoWrapper>
    </StyledTapDisplayCard>
  );
};

export default TapDisplayCard;
